var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDataGrid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 1515,
  height: 929,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#DataGrid_svg__a)",
  fillRule: "evenodd",
  d: "M304.184 174.046c15.579-49.082 30.077-79.642 43.471-91.69 37.091-33.346 88.375-15.198 99.277-12.599 38.302 9.156 25.848-51.096 58.71-63.343 21.899-8.161 39.91 1.815 54.044 29.927C572.199 10.114 591.267-1.9 616.891.243c38.442 3.244 51.895 132.636 104.718 104.312 52.834-28.335 117.606-34.81 145.274 7.295 5.98 9.109 8.271-5.023 48.946-53.274C956.503 10.313 997.06-10.95 1080.27 17.15c37.83 12.762 68.94 47.36 93.36 103.785 0 80.532 59.45 128.209 178.33 142.997 178.33 22.188 39.91 213.261-178.33 269.217-218.243 55.967-720.706 86.175-993.373-55.218C-1.521 383.689 39.8 282.386 304.184 174.046",
  clipRule: "evenodd",
  opacity: 0.8
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#DataGrid_svg__b)",
  d: "M751.346 885.683c181.6 0 328.814-33.958 328.814-75.848s-147.214-75.849-328.814-75.849c-181.599 0-328.815 33.959-328.815 75.849s147.216 75.848 328.815 75.848"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#DataGrid_svg__c)",
  fillRule: "evenodd",
  d: "M1306.48 904.488c-247.23 61.798-1091.113-8.887-1180.933-41.168-43.717-15.724-83.123-45.289-118.205-88.704a32.944 32.944 0 0 1-4.094-35 33.1 33.1 0 0 1 12.238-13.695 33.24 33.24 0 0 1 17.68-5.083H1507.81c30.61 81.234-36.5 142.447-201.33 183.65",
  clipRule: "evenodd",
  opacity: 0.675
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#718704",
  d: "M1003.66 606.558 891.209 475.515a28.6 28.6 0 0 0-9.688-7.382 28.7 28.7 0 0 0-11.894-2.688H627.835c-8.294 0-16.178 3.794-21.582 10.07L493.805 606.558v71.938h509.855z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#DataGrid_svg__d)",
  d: "m971.776 681.161-98.42-114.136a25.1 25.1 0 0 0-8.601-6.313 25.2 25.2 0 0 0-10.456-2.176H643.125c-7.249 0-14.333 2.997-19.056 8.489l-98.421 114.136v62.688h446.128z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F7",
  fillRule: "evenodd",
  d: "M568.476 202.955h363.138a21.37 21.37 0 0 1 15.119 6.273 21.44 21.44 0 0 1 6.263 15.145v499.816c0 5.68-2.253 11.128-6.263 15.145a21.37 21.37 0 0 1-15.119 6.273H568.476a21.37 21.37 0 0 1-15.12-6.273 21.44 21.44 0 0 1-6.262-15.145V224.373c0-5.68 2.253-11.128 6.262-15.145a21.37 21.37 0 0 1 15.12-6.273",
  clipRule: "evenodd"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#B7D523",
  opacity: 0.25
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M617.149 469.443h265.742c3.207 0 6.283 1.276 8.55 3.548a12.122 12.122 0 0 1 0 17.129 12.08 12.08 0 0 1-8.55 3.547H617.149a12.08 12.08 0 0 1-8.55-3.547 12.12 12.12 0 0 1 0-17.129 12.08 12.08 0 0 1 8.55-3.548m0 62.986h265.742c3.208 0 6.284 1.276 8.552 3.548a12.13 12.13 0 0 1 0 17.133 12.08 12.08 0 0 1-8.552 3.548H617.149a12.08 12.08 0 0 1-8.552-3.548 12.127 12.127 0 0 1 0-17.133 12.08 12.08 0 0 1 8.552-3.548",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M882.889 407.752H617.146a12.08 12.08 0 0 0-8.55 3.547 12.127 12.127 0 0 0 0 17.129 12.08 12.08 0 0 0 8.55 3.548h265.743a12.08 12.08 0 0 0 8.55-3.548 12.127 12.127 0 0 0 0-17.129 12.08 12.08 0 0 0-8.55-3.547M882.889 342.641H617.146a12.08 12.08 0 0 0-8.55 3.547 12.125 12.125 0 0 0 0 17.129 12.08 12.08 0 0 0 8.55 3.548h265.743a12.08 12.08 0 0 0 8.55-3.548 12.125 12.125 0 0 0 0-17.129 12.08 12.08 0 0 0-8.55-3.547M882.889 277.531H617.146a12.08 12.08 0 0 0-8.55 3.548 12.125 12.125 0 0 0 0 17.129 12.08 12.08 0 0 0 8.55 3.547h265.743c3.207 0 6.282-1.276 8.55-3.547a12.125 12.125 0 0 0 0-17.129 12.08 12.08 0 0 0-8.55-3.548"
}))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#B7D523",
  d: "M1003.66 760.936c0 9.987-4.514 18.968-11.634 24.986l-1.445 1.171a32.48 32.48 0 0 1-19.621 6.557H526.513c-4.018 0-7.86-.726-11.408-2.061l-1.762-.703a32.9 32.9 0 0 1-14.222-12.097 32.73 32.73 0 0 1-5.316-17.865V607.342h123.703c13.664 0 24.673 11.205 24.673 24.799v.175c0 13.606 11.138 24.577 24.802 24.577H830.48a24.87 24.87 0 0 0 17.514-7.23 24.7 24.7 0 0 0 7.287-17.44c0-13.653 11.021-24.881 24.673-24.881h123.716z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "DataGrid_svg__a",
  x1: 783.433,
  x2: 783.433,
  y1: 432.634,
  y2: -102.257,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F5F7",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F5F7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "DataGrid_svg__b",
  x1: 717.084,
  x2: 717.084,
  y1: 885.683,
  y2: 733.986,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#96A1C5",
  stopOpacity: 0.373
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "DataGrid_svg__c",
  x1: 757.5,
  x2: 757.5,
  y1: 928.999,
  y2: 679.882,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#919191",
  stopOpacity: 0.15
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "DataGrid_svg__d",
  x1: 808.248,
  x2: 808.248,
  y1: 743.849,
  y2: 548.684,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCE9FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B6CFFF"
})))));
export { SvgDataGrid as ReactComponent };
export default __webpack_public_path__ + "ae9ed81d0c0be1f2f8ba90d5874e9c76.svg";